import { ScreenShare } from '@mui/icons-material';
import { ControlButton, ControlButtonProps } from './ControlButton.component';
import { useVideoStyles } from './styles';
import { useVideoCallSidebarContext } from '../Layout';

export type ScreenShareControlButtonProps = {
  disableToggle?: boolean | string;
} & Pick<ControlButtonProps, 'isActive' | 'onToggleActive'>;

export const ScreenShareControlButton: React.VFC<ScreenShareControlButtonProps> = ({ disableToggle, ...props }) => {
  const { activeItemId } = useVideoCallSidebarContext();
  const { classes } = useVideoStyles({});
  const isInCallSchedulingOpened = activeItemId === 'scheduling';
  const icon = <ScreenShare />;

  let disabledToggleTooltip: string | undefined;

  if (typeof disableToggle === 'string') {
    disabledToggleTooltip = disableToggle;
  }

  return (
    <ControlButton
      enabled={{
        icon,
        tooltipTitle: disabledToggleTooltip ?? 'Stop Screen Share',
        className: classes.screenShareEnabled,
      }}
      disabled={{
        icon,
        tooltipTitle: disabledToggleTooltip ?? 'Share Screen',
        className: classes.screenShareDisabled
      }}
      disableToggle={Boolean(disableToggle) || isInCallSchedulingOpened}
      {...props}
    />
  );
};
